import { Typography } from '@scale/scaleui';
import { BrowserRouter } from 'react-router-dom';
import { AdminPageContent } from 'react-scale/components/ExpertManagement/AdminPage/AdminPageContent';

export const AdminPage: React.FC = () => {
  return (
    <div className="p-8 h-full flex flex-col items-start">
      <Typography.H4>Admin Page</Typography.H4>
      <BrowserRouter basename="corp/expert-management/admin">
        <AdminPageContent />
      </BrowserRouter>
    </div>
  );
};
